angular.module('salesPath2.spd', ['salesPath2.loader']);